import React from 'react';
import { ReactElement } from 'react';
import { IRoute } from 'interfaces/routesInt';
import ManageRoutes from 'routes/manageRoute';
import urls from 'routes/urls';
import DeliveryNoteDetails from 'containers/procurement/deliveryNotes/DeliveryNoteDetails';

const protectedPageElement: ReactElement = <ManageRoutes />;
const commonElements = {
  element: protectedPageElement,
  isProtected: true,
};

const protectedRoutes: IRoute[] = [
  {
    path: urls.dashboard,
    key: urls.dashboard,
    ...commonElements,
  },
  {
    path: urls.sales,
    key: urls.sales,
    ...commonElements,
  },
  {
    path: urls.pos,
    key: urls.pos,
    ...commonElements,
  },
  {
    path: urls.salesHistory,
    key: urls.salesHistory,
    ...commonElements,
  },
  {
    path: urls.inventory,
    key: urls.inventory,
    ...commonElements,
  },
  {
    path: urls.products,
    key: urls.products,
    ...commonElements,
  },
  {
    path: urls.funds,
    key: urls.funds,
    ...commonElements,
  },
  {
    path: urls.expenses,
    key: urls.expenses,
    ...commonElements,
  },
  {
    path: urls.archivedStock,
    key: urls.archivedStock,
    ...commonElements,
  },
  {
    path: urls.settings,
    key: urls.settings,
    ...commonElements,
  },
  {
    path: urls.customers,
    key: urls.customers,
    ...commonElements,
  },
  {
    path: urls.productCategory,
    key: urls.productCategory,
    ...commonElements,
  },
  {
    path: urls.debts,
    key: urls.debts,
    ...commonElements,
  },
  {
    path: urls.pageNotFound,
    key: urls.pageNotFound,
    ...commonElements,
  },
  {
    path: urls.suppliers,
    key: urls.suppliers,
    ...commonElements,
  },
  {
    path: urls.manageBranchs,
    key: urls.manageBranchs,
    ...commonElements,
  },
  {
    path: urls.stock,
    key: urls.stock,
    ...commonElements,
  },
  {
    path: urls.salesV2,
    key: urls.salesV2,
    ...commonElements,
  },
  {
    path: urls.wholesale,
    key: urls.wholesale,
    ...commonElements,
  },
  {
    path: urls.purchaseOrders,
    key: urls.purchaseOrders,
    ...commonElements,
  },
  {
    path: urls.createPurchaseOrder,
    key: urls.createPurchaseOrder,
    ...commonElements,
  },
  {
    path: urls.deliveryNotes,
    key: urls.deliveryNotes,
    ...commonElements,
  },

  {
    path: urls.deliveryNoteDetails,
    key: urls.deliveryNoteDetails,
    ...commonElements,
    element: <DeliveryNoteDetails />,
  },
  {
    path: urls.createDeliveryNote,
    key: urls.createDeliveryNote,
    ...commonElements,
  },
  {
    path: urls.pharmacyDashboard,
    key: urls.pharmacyDashboard,
    ...commonElements,
  },
  {
    path: urls.prescriptions,
    key: urls.prescriptions,
    ...commonElements,
  },
  {
    path: urls.createPrescription,
    key: urls.createPrescription,
    ...commonElements,
  },
  {
    path: urls.medications,
    key: urls.medications,
    ...commonElements,
  },
  {
    path: urls.pharmacists,
    key: urls.pharmacists,
    ...commonElements,
  },
  {
    path: urls.createPatient,
    key: urls.createPatient,
    ...commonElements,
  },
  {
    path: urls.patients,
    key: urls.patients,
    ...commonElements,
  },
  {
    path: urls.patientHistory,
    key: urls.patientHistory,
    ...commonElements,
  },
  {
    path: urls.pharmacyBatches,
    key: urls.pharmacyBatches,
    ...commonElements,
  },
  {
    path: urls.pharmacyPOS,
    key: urls.pharmacyPOS,
    ...commonElements,
  },
  {
    path: urls.pharmacySalesHistory,
    key: urls.pharmacySalesHistory,
    ...commonElements,
  },
  {
    path: urls.pharmacyBranches,
    key: urls.pharmacyBranches,
    ...commonElements,
  },
  {
    path: urls.pharmacyReports,
    key: urls.pharmacyReports,
    ...commonElements,
  },
  {
    path: urls.pharmacyDispensing,
    key: urls.pharmacyDispensing,
    ...commonElements,
  },
  // Pharmacy Procurement
  {
    path: urls.pharmacyPurchaseOrders,
    key: urls.pharmacyPurchaseOrders,
    ...commonElements,
  },
  {
    path: urls.pharmacyPurchaseOrderDetail,
    key: urls.pharmacyPurchaseOrderDetail,
    ...commonElements,
  },
  {
    path: urls.pharmacyStockTransfers,
    key: urls.pharmacyStockTransfers,
    ...commonElements,
  },
  {
    path: urls.pharmacyStockTransferDetail,
    key: urls.pharmacyStockTransferDetail,
    ...commonElements,
  },
  {
    path: urls.pharmacyGoodsReceiving,
    key: urls.pharmacyGoodsReceiving,
    ...commonElements,
  },
  {
    path: urls.pharmacyGoodsReceivingDetail,
    key: urls.pharmacyGoodsReceivingDetail,
    ...commonElements,
  },
  {
    path: urls.barDashboard,
    key: urls.barDashboard,
    ...commonElements,
  },
  {
    path: urls.barPOS,
    key: urls.barPOS,
    ...commonElements,
  },
  {
    path: urls.comptoirs,
    key: urls.comptoirs,
    ...commonElements,
  },
  {
    path: urls.barStock,
    key: urls.barStock,
    ...commonElements,
  },
  {
    path: urls.barMovements,
    key: urls.barMovements,
    ...commonElements,
  },
  {
    path: urls.barRecipes,
    key: urls.barRecipes,
    ...commonElements,
  },
  {
    path: urls.recipeDetails,
    key: urls.recipeDetails,
    ...commonElements,
  },
  {
    path: urls.barTabs,
    key: urls.barTabs,
    ...commonElements,
  },
  {
    path: urls.barShifts,
    key: urls.barShifts,
    ...commonElements,
  },
  {
    path: urls.barAnalytics,
    key: urls.barAnalytics,
    ...commonElements,
  },
  {
    path: urls.salesAnalytics,
    key: urls.salesAnalytics,
    ...commonElements,
  },
  {
    path: urls.inventoryAnalytics,
    key: urls.inventoryAnalytics,
    ...commonElements,
  },
  {
    path: urls.customerAnalytics,
    key: urls.customerAnalytics,
    ...commonElements,
  },
  {
    path: urls.financialAnalytics,
    key: urls.financialAnalytics,
    ...commonElements,
  },
  {
    path: urls.stockMovements,
    key: urls.stockMovements,
    ...commonElements,
  },
  {
    path: urls.createRecipe,
    key: urls.createRecipe,
    ...commonElements,
  },
  {
    path: urls.barRecipeEdit,
    key: urls.barRecipeEdit,
    ...commonElements,
  },
  {
    path: urls.barMenus,
    key: urls.barMenus,
    ...commonElements,
  },
  {
    path: urls.barManageMenu,
    key: urls.barManageMenu,
    ...commonElements,
  },
  {
    path: urls.barBottles,
    key: urls.barBottles,
    ...commonElements,
  },
  {
    path: urls.auditLogs,
    key: urls.auditLogs,
    ...commonElements,
  },
  {
    path: urls.reports,
    key: urls.reports,
    ...commonElements,
  },
  {
    path: urls.retailInventory,
    key: urls.retailInventory,
    ...commonElements,
  },
  {
    path: urls.retailSuppliers,
    key: urls.retailSuppliers,
    ...commonElements,
  },
  {
    path: urls.retailReports,
    key: urls.retailReports,
    ...commonElements,
  },
  {
    path: urls.storeFulfillment,
    key: urls.storeFulfillment,
    ...commonElements,
  },
  // Owner Dashboard (cross-branch management)
  {
    path: urls.ownerDashboard,
    key: urls.ownerDashboard,
    ...commonElements,
  },
  // Website Management (Fukkoni marketing site)
  {
    path: urls.websitePricingPlans,
    key: urls.websitePricingPlans,
    ...commonElements,
  },
  {
    path: urls.websiteVisitors,
    key: urls.websiteVisitors,
    ...commonElements,
  },
  {
    path: urls.subscriptionRenew,
    key: urls.subscriptionRenew,
    ...commonElements,
  },
  // Super Admin Portal
  {
    path: urls.superAdminDashboard,
    key: urls.superAdminDashboard,
    ...commonElements,
  },
  {
    path: urls.superAdminShops,
    key: urls.superAdminShops,
    ...commonElements,
  },
  {
    path: urls.superAdminUsers,
    key: urls.superAdminUsers,
    ...commonElements,
  },
  {
    path: urls.superAdminActivity,
    key: urls.superAdminActivity,
    ...commonElements,
  },
  {
    path: urls.superAdminPayments,
    key: urls.superAdminPayments,
    ...commonElements,
  },
  {
    path: urls.superAdminSettings,
    key: urls.superAdminSettings,
    ...commonElements,
  },
  {
    path: urls.superAdminStorefronts,
    key: urls.superAdminStorefronts,
    ...commonElements,
  },

  // Restaurant
  {
    path: urls.restaurantDashboard,
    key: urls.restaurantDashboard,
    ...commonElements,
  },
  {
    path: urls.restaurantTables,
    key: urls.restaurantTables,
    ...commonElements,
  },
  {
    path: urls.restaurantReservations,
    key: urls.restaurantReservations,
    ...commonElements,
  },
  {
    path: urls.restaurantKitchen,
    key: urls.restaurantKitchen,
    ...commonElements,
  },
  {
    path: urls.restaurantTableReports,
    key: urls.restaurantTableReports,
    ...commonElements,
  },
  {
    path: urls.restaurantTableTerms,
    key: urls.restaurantTableTerms,
    ...commonElements,
  },
  {
    path: urls.hospitalHR,
    key: urls.hospitalHR,
    ...commonElements,
  },
  {
    path: urls.hospitalPayroll,
    key: urls.hospitalPayroll,
    ...commonElements,
  },
  {
    path: urls.hospitalManagement,
    key: urls.hospitalManagement,
    ...commonElements,
  },
  {
    path: urls.hospitalTriage.replace('/:encounterId', ''),
    key: 'hospital-triage-base',
    ...commonElements,
  },
  {
    path: urls.hospitalConsultation.replace('/:encounterId', ''),
    key: 'hospital-consultation-base',
    ...commonElements,
  },
  {
    path: urls.hospitalDashboard,
    key: urls.hospitalDashboard,
    ...commonElements,
  },
  {
    path: urls.hospitalQueue,
    key: urls.hospitalQueue,
    ...commonElements,
  },
  {
    path: urls.hospitalAppointments,
    key: urls.hospitalAppointments,
    ...commonElements,
  },
  {
    path: urls.hospitalLabs,
    key: urls.hospitalLabs,
    ...commonElements,
  },
  {
    path: urls.hospitalWards,
    key: urls.hospitalWards,
    ...commonElements,
  },
  {
    path: urls.hospitalTriage,
    key: urls.hospitalTriage,
    ...commonElements,
  },
  {
    path: urls.hospitalConsultation,
    key: urls.hospitalConsultation,
    ...commonElements,
  },
  {
    path: urls.hospitalFinance,
    key: urls.hospitalFinance,
    ...commonElements,
  },
  {
    path: urls.hospitalPACS,
    key: urls.hospitalPACS,
    ...commonElements,
  },
  {
    path: urls.hospitalReports,
    key: urls.hospitalReports,
    ...commonElements,
  },
  {
    path: urls.hospitalSettings,
    key: urls.hospitalSettings,
    ...commonElements,
  },
  {
    path: urls.hospitalAmbulance,
    key: urls.hospitalAmbulance,
    ...commonElements,
  },
  {
    path: urls.hrmEmployees,
    key: urls.hrmEmployees,
    ...commonElements,
  },
  {
    path: urls.hrmPayroll,
    key: urls.hrmPayroll,
    ...commonElements,
  },
  // Domain Microservices - Coffee Shop
  {
    path: urls.coffeeDashboard,
    key: urls.coffeeDashboard,
    ...commonElements,
  },
  {
    path: urls.coffeePOS,
    key: urls.coffeePOS,
    ...commonElements,
  },
  {
    path: urls.coffeeOrders,
    key: urls.coffeeOrders,
    ...commonElements,
  },
  {
    path: urls.coffeeRecipes,
    key: urls.coffeeRecipes,
    ...commonElements,
  },
  {
    path: urls.coffeeModifiers,
    key: urls.coffeeModifiers,
    ...commonElements,
  },
  {
    path: urls.coffeeShifts,
    key: urls.coffeeShifts,
    ...commonElements,
  },
  {
    path: urls.coffeeSpillage,
    key: urls.coffeeSpillage,
    ...commonElements,
  },
  {
    path: urls.coffeeLoyalty,
    key: urls.coffeeLoyalty,
    ...commonElements,
  },
  // Domain Microservices - Grocery & Supermarket
  {
    path: urls.groceryDashboard,
    key: urls.groceryDashboard,
    ...commonElements,
  },
  {
    path: urls.groceryPOS,
    key: urls.groceryPOS,
    ...commonElements,
  },
  {
    path: urls.groceryInventory,
    key: urls.groceryInventory,
    ...commonElements,
  },
  {
    path: urls.groceryExpiries,
    key: urls.groceryExpiries,
    ...commonElements,
  },
  {
    path: urls.grocerySpoilage,
    key: urls.grocerySpoilage,
    ...commonElements,
  },
  {
    path: urls.grocerySalesHistory,
    key: urls.grocerySalesHistory,
    ...commonElements,
  },
  {
    path: urls.groceryReports,
    key: urls.groceryReports,
    ...commonElements,
  },
  {
    path: urls.clothingDashboard,
    key: urls.clothingDashboard,
    ...commonElements,
  },
  {
    path: urls.shoeDashboard,
    key: urls.shoeDashboard,
    ...commonElements,
  },
  {
    path: urls.shoeCatalog,
    key: urls.shoeCatalog,
    ...commonElements,
  },
  {
    path: urls.shoePOS,
    key: urls.shoePOS,
    ...commonElements,
  },
  {
    path: urls.shoePrepacks,
    key: urls.shoePrepacks,
    ...commonElements,
  },
  {
    path: urls.shoeAudits,
    key: urls.shoeAudits,
    ...commonElements,
  },
  {
    path: urls.shoeMismatched,
    key: urls.shoeMismatched,
    ...commonElements,
  },
  {
    path: urls.shoeCare,
    key: urls.shoeCare,
    ...commonElements,
  },
  {
    path: urls.shoeLabels,
    key: urls.shoeLabels,
    ...commonElements,
  },
  {
    path: urls.shoeSizeConverter,
    key: urls.shoeSizeConverter,
    ...commonElements,
  },
  {
    path: urls.shoeSalesHistory,
    key: urls.shoeSalesHistory,
    ...commonElements,
  },
  {
    path: urls.hardwareDashboard,
    key: urls.hardwareDashboard,
    ...commonElements,
  },
  {
    path: urls.hardwareCatalog,
    key: urls.hardwareCatalog,
    ...commonElements,
  },
  {
    path: '/hardware/catalog',
    key: 'hardware-catalog-alt',
    ...commonElements,
  },
  {
    path: urls.hardwareRentals,
    key: urls.hardwareRentals,
    ...commonElements,
  },
  {
    path: '/hardware/rentals',
    key: 'hardware-rentals-direct',
    ...commonElements,
  },
  {
    path: '/tool-rentals',
    key: 'hardware-rentals-alt',
    ...commonElements,
  },
  {
    path: '/hardware/pos',
    key: 'hardware-pos',
    ...commonElements,
  },
  {
    path: '/hardware/debts',
    key: 'hardware-debts',
    ...commonElements,
  },
  {
    path: '/hardware/analytics',
    key: 'hardware-analytics',
    ...commonElements,
  },
  {
    path: '/hardware/customers',
    key: 'hardware-customers',
    ...commonElements,
  },
  {
    path: '/hardware/reports',
    key: 'hardware-reports',
    ...commonElements,
  },
  {
    path: urls.jewelryDashboard,
    key: urls.jewelryDashboard,
    ...commonElements,
  },
  {
    path: urls.jewelryVault,
    key: urls.jewelryVault,
    ...commonElements,
  },
  {
    path: urls.jewelryPOS,
    key: urls.jewelryPOS,
    ...commonElements,
  },
  {
    path: urls.jewelrySalesHistory,
    key: urls.jewelrySalesHistory,
    ...commonElements,
  },
  {
    path: urls.jewelryCertificates,
    key: urls.jewelryCertificates,
    ...commonElements,
  },
  {
    path: urls.jewelryTradeIns,
    key: urls.jewelryTradeIns,
    ...commonElements,
  },
  {
    path: urls.jewelrySpotRates,
    key: urls.jewelrySpotRates,
    ...commonElements,
  },
  {
    path: urls.jewelryReports,
    key: urls.jewelryReports,
    ...commonElements,
  },
  // Mobile Money & Agency Banking
  {
    path: urls.mobileMoneyDashboard,
    key: urls.mobileMoneyDashboard,
    ...commonElements,
  },
  {
    path: urls.mobileMoneyPOS,
    key: urls.mobileMoneyPOS,
    ...commonElements,
  },
  {
    path: urls.mobileMoneyFloats,
    key: urls.mobileMoneyFloats,
    ...commonElements,
  },
  {
    path: urls.mobileMoneyLedger,
    key: urls.mobileMoneyLedger,
    ...commonElements,
  },
  {
    path: urls.mobileMoneyReconciliation,
    key: urls.mobileMoneyReconciliation,
    ...commonElements,
  },
  {
    path: urls.mobileMoneyDebts,
    key: urls.mobileMoneyDebts,
    ...commonElements,
  },
  {
    path: urls.mobileMoneyCustomerHistory,
    key: urls.mobileMoneyCustomerHistory,
    ...commonElements,
  },
  {
    path: urls.mobileMoneyTransactionsCustomerHistory,
    key: urls.mobileMoneyTransactionsCustomerHistory,
    ...commonElements,
  },
  {
    path: urls.merchantOnlineStore,
    key: urls.merchantOnlineStore,
    ...commonElements,
  },
  {
    path: urls.storefrontProducts,
    key: urls.storefrontProducts,
    ...commonElements,
  },
  {
    path: urls.storefrontOrders,
    key: urls.storefrontOrders,
    ...commonElements,
  },
  {
    path: urls.storefrontSettings,
    key: urls.storefrontSettings,
    ...commonElements,
  },
  // Hotel & Hospitality PMS
  {
    path: urls.hotelDashboard,
    key: urls.hotelDashboard,
    ...commonElements,
  },
  {
    path: urls.hotelRooms,
    key: urls.hotelRooms,
    ...commonElements,
  },
  {
    path: urls.hotelReservations,
    key: urls.hotelReservations,
    ...commonElements,
  },
  {
    path: urls.hotelHousekeeping,
    key: urls.hotelHousekeeping,
    ...commonElements,
  },
  {
    path: urls.hotelFolios,
    key: urls.hotelFolios,
    ...commonElements,
  },
  {
    path: urls.hotelReports,
    key: urls.hotelReports,
    ...commonElements,
  },
  {
    path: urls.hotelGuests,
    key: urls.hotelGuests,
    ...commonElements,
  },
  // 7 New Business Verticals
  { path: urls.realEstateDashboard, key: urls.realEstateDashboard, ...commonElements },
  { path: urls.realEstateProperties, key: urls.realEstateProperties, ...commonElements },
  { path: urls.realEstateUnits, key: urls.realEstateUnits, ...commonElements },
  { path: urls.realEstateRentPayments, key: urls.realEstateRentPayments, ...commonElements },
  { path: urls.realEstateMaintenance, key: urls.realEstateMaintenance, ...commonElements },
  { path: urls.barbershopDashboard, key: urls.barbershopDashboard, ...commonElements },
  { path: urls.barbershopQueue, key: urls.barbershopQueue, ...commonElements },
  { path: urls.barbershopChairs, key: urls.barbershopChairs, ...commonElements },
  { path: urls.barbershopServices, key: urls.barbershopServices, ...commonElements },
  { path: urls.spaDashboard, key: urls.spaDashboard, ...commonElements },
  { path: urls.spaBookings, key: urls.spaBookings, ...commonElements },
  { path: urls.spaRooms, key: urls.spaRooms, ...commonElements },
  { path: urls.spaTreatments, key: urls.spaTreatments, ...commonElements },
  { path: urls.spaMemberships, key: urls.spaMemberships, ...commonElements },
  { path: urls.tailoringDashboard, key: urls.tailoringDashboard, ...commonElements },
  { path: urls.tailoringOrders, key: urls.tailoringOrders, ...commonElements },
  { path: urls.tailoringMeasurements, key: urls.tailoringMeasurements, ...commonElements },
  { path: urls.tailoringFabrics, key: urls.tailoringFabrics, ...commonElements },
  { path: urls.professionalServicesDashboard, key: urls.professionalServicesDashboard, ...commonElements },
  { path: urls.professionalServicesProjects, key: urls.professionalServicesProjects, ...commonElements },
  { path: urls.professionalServicesTimesheets, key: urls.professionalServicesTimesheets, ...commonElements },
  { path: urls.professionalServicesRetainers, key: urls.professionalServicesRetainers, ...commonElements },
  { path: urls.salonDashboard, key: urls.salonDashboard, ...commonElements },
  { path: urls.salonAppointments, key: urls.salonAppointments, ...commonElements },
  { path: urls.salonStations, key: urls.salonStations, ...commonElements },
  { path: urls.salonServices, key: urls.salonServices, ...commonElements },
  { path: urls.salonFormulas, key: urls.salonFormulas, ...commonElements },
  { path: urls.carRentalDashboard, key: urls.carRentalDashboard, ...commonElements },
  { path: urls.carRentalVehicles, key: urls.carRentalVehicles, ...commonElements },
  { path: urls.carRentalRentals, key: urls.carRentalRentals, ...commonElements },
  { path: urls.carRentalInspections, key: urls.carRentalInspections, ...commonElements },
];

export default protectedRoutes;
